import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectionListItem from '@wix/da-ds/pkg/SelectionList/SelectionListItem';
import { DeviationResourceType } from '../../../types/deviation';
import { BiData } from '@wix/da-bi/pkg/events';
var ShareInPost = function (_a) {
    var deviation = _a.deviation, shareToPost = _a.shareToPost;
    var t = useTranslation().t;
    return (React.createElement(SelectionListItem, { label: t('deviationview.tierCard.moreActionsMenu.item.shareInPost'), onClick: shareToPost, biData: BiData({
            evid: 356,
            typeid: DeviationResourceType.TIER,
            itemid: deviation.deviationId,
            social_share: 'da_post',
            deviationid: deviation.deviationId,
        }) }));
};
ShareInPost.displayName = 'ShareInPost';
export default ShareInPost;
//# sourceMappingURL=ShareInPost.js.map